<div class="fx-row fx-wrap align-items-center justify-content-start  fx-flex-100">
    <div class="fx-row fx-wrap align-items-start justify-content-between fx-flex-100" *ngIf="organization">
        <div class="fx-column align-items-start justify-content-start">
            <span class="title bold">{{'ORGANIZATION.CAMPAIGNS_TAB' | translate}}</span>
            <span class="text light">{{'ORGANIZATION.CAMPAIGNS_HINT' | translate}}</span>
        </div>
        <div class="fx-row align-items-center justify-content-end">
            <button class="main-button ml-10" (click)="create()" aclBasedElement resource="USER" [scopes]="['C']">
                <div class="fx-row align-items-center justify-content-center">
                    <mat-icon class="white mr-5" fontSet="material-icons-outlined">schedule_send</mat-icon>
                    {{'ORGANIZATION.CREATE_CAMPAIGN' | translate}}
                </div>
            </button>
        </div>
    </div>
    <mat-divider class="mv-16 fx-flex-100"></mat-divider>
    <table mat-table [dataSource]="campaigns.docs" style="z-index: 0;">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'CAMPAIGN.NAME' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <span class="text bold" [class.red]="!campaign.enabled" [class.light]="isCampaignInactive(campaign)"
                    [matTooltip]="campaignTooltip(campaign)"
                    [matTooltipDisabled]="!hasTooltip(campaign)">{{campaign.name}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'CAMPAIGN.TYPE' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <div class="fx-column">
                    <span class="text">{{'CAMPAIGN.TYPE_'+campaign.type | translate}}</span>
                    <span class="small light"
                        *ngIf="campaign.entity && campaign.entity.type && campaign.entity.type !== 'none'">
                        {{campaign.entity.label}}
                    </span>
                </div>

            </td>
        </ng-container>
        <ng-container matColumnDef="targets">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'CAMPAIGN.TARGETS' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <ng-container [ngSwitch]="campaign.type">
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'CASE'">
                        <span class="text main">{{campaign.targets[0].reference}}</span>
                        <span class="text ">{{campaign.targets[0].trademark.name ||
                            campaign.targets[0].trademark.identifierNumber}}</span>
                    </div>
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'COUNTRY'">
                        <div class="fx-row justify-content-start align-items-center"
                            *ngIf="campaign.targets.length == 1">
                            <app-document-countries [territories]="[campaign.targets[0].code]"></app-document-countries>
                            <span class="text ml-5">{{'TERRITORIES.'+campaign.targets[0].code.toUpperCase() |
                                translate}}</span>
                        </div>
                    </div>
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'INDIVIDUALS'">
                        <div class="fx-row justify-content-start align-items-center"
                            *ngIf="campaign.targets.length > 1">
                            <span class="text main">{{campaign.targets.length}}
                                {{'ENTITIES.USERS' | translate}}</span>
                            <mat-icon class="main ml-5 clickable" inline fontSet="material-icons-outlined"
                                [cdkMenuTriggerFor]="menuUserTargets">info</mat-icon>
                            <ng-template #menuUserTargets>
                                <mat-card class="menu-container p-8 elevation" cdkMenu>
                                    <div class="fx-row justify-content-start align-items-center pb-5 pt-5"
                                        *ngFor="let target of campaign.targets; let index = index"
                                        [class.border-bottom]="index < campaign.targets.length - 1">
                                        <app-avatar [user]="target" [size]="27"></app-avatar>
                                        <div class="fx-column align-items-start justify-content-start ml-10">
                                            <span class="text">{{target.firstName}}
                                                {{target.lastName}}</span>
                                            <span class="small light">{{target.email}}</span>
                                        </div>
                                    </div>
                                </mat-card>
                            </ng-template>
                        </div>

                        <div class="fx-row justify-content-start align-items-center"
                            *ngIf="campaign.targets.length == 1">
                            <app-avatar [user]="campaign.targets[0]" [size]="27"></app-avatar>
                            <div class="fx-column align-items-start justify-content-start ml-10">
                                <span class="text">{{campaign.targets[0].firstName}}
                                    {{campaign.targets[0].lastName}}</span>
                                <span class="small light">{{campaign.targets[0].email}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'OPERATORS'">
                        <span class="text ">All operators within your organization</span>
                    </div>
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'CASE_OPERATORS'">
                        <span class="text ">All case operators within your organization</span>
                    </div>
                    <div class="fx-flex-100 fx-column" *ngSwitchCase="'COUNTRY_OPERATORS'">
                        <span class="text ">All country operators within your organization</span>
                    </div>
                </ng-container>
                <!-- <div class="fx-row align-items-center justify-content-start">
                    <a [href]="'mailto:'+user.email">{{user.email}}</a>
                    <mat-icon class="dark ml-5 clickable" inline fontSet="material-icons-outlined"
                        [cdkMenuTriggerFor]="menu"
                        *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">info</mat-icon>
                    <mat-icon class="red ml-5" inline fontSet="material-icons-outlined"
                        [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'ORGANIZATION.USER_SUSPENDED' | translate"
                        *ngIf="user.isSuspended">block</mat-icon>
                    <ng-template #menu>
                        <mat-card class="menu-container p-8 elevation" cdkMenu
                            *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">
                            <span class="small dark">{{'USER.INVITED_BY' | translate}}</span>
                            <div class="fx-row justify-content-start align-items-center">
                                <app-avatar [user]="user.invitedBy" [size]="20"></app-avatar>
                                <span class="small ml-5">{{user.invitedBy.firstName}} {{user.invitedBy.lastName}}</span>
                            </div>
                        </mat-card>
                    </ng-template>
                </div> -->
            </td>
        </ng-container>
        <ng-container matColumnDef="schedule">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'CAMPAIGN.SCHEDULE' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <span class="text">{{'CAMPAIGN.SCHEDULE_'+campaign.schedule.toUpperCase() | translate}}</span>
                <!-- <div class="fx-row justify-content-start align-items-center" *ngIf="campaign.schedule == 'once'">
                    <mat-icon class="light mr-5" inline fontSet="material-icons-outlined">calendar_month</mat-icon>
                    <span class="text light"
                        *ngIf="(!campaign.lastExecution || !campaign.lastExecution.executedAt)">{{'CAMPAIGN.SCHEDULED'|
                        translate}}</span>
                    <span class="text light"
                        *ngIf="(campaign.lastExecution && campaign.lastExecution.executedAt)">{{formatDate(campaign.lastExecution.executedAt)}}</span>
                </div> -->

            </td>
        </ng-container>
        <ng-container matColumnDef="lastExecution">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'CAMPAIGN.LAST_EXECUTION' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <span class="text light" *ngIf="!campaign.lastExecution || !campaign.lastExecution.executedAt">-</span>
                <div class="fx-column" *ngIf="(campaign.lastExecution && campaign.lastExecution.executedAt)">
                    <span class="text main bold">{{formatDate(campaign.lastExecution.executedAt)}}</span>
                    <div class="fx-row justify-content-start align-items-center"
                        *ngIf="campaign.lastExecution.recipients.length > 0">
                        <span class="text dark">{{campaign.lastExecution.recipients.length}}
                            {{'CAMPAIGN.RECIPIENTS' | translate}}</span>
                        <mat-icon class="dark ml-5 clickable" inline fontSet="material-icons-outlined"
                            [cdkMenuTriggerFor]="menuUserRecipients">info</mat-icon>
                        <ng-template #menuUserRecipients>
                            <mat-card class="menu-container p-8 elevation" cdkMenu>
                                <div class="fx-row justify-content-start align-items-center pb-5 pt-5"
                                    *ngFor="let recipient of campaign.lastExecution.recipients; let index = index"
                                    [class.border-bottom]="index < campaign.lastExecution.recipients.length - 1">
                                    <app-avatar [user]="recipient" [size]="27"></app-avatar>
                                    <div class="fx-column align-items-start justify-content-start ml-10">
                                        <span class="text">{{recipient.firstName}}
                                            {{recipient.lastName}}</span>
                                        <span class="small light">{{recipient.email}}</span>
                                    </div>
                                </div>
                            </mat-card>
                        </ng-template>
                    </div>
                </div>
            </td>
        </ng-container>
        <!-- <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                    {{'USER.REGISTRATION' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let user">
                <span class="text light" *ngIf="user.passwordVerified">{{formatDate(user.createdAt)}}</span>
                <div *ngIf="!user.passwordVerified" class="fx-row fx-wrap align-items-center justify-content-start">
                    <mat-icon class="dark mr-5 clickable" fontSet="material-icons-outlined" inline
                        [cdkMenuTriggerFor]="menuInvite">email</mat-icon>
                    <span class="small light bold">{{'USER.PENDING_INVITE' | translate}}</span>
                    <ng-template #menuInvite>
                        <mat-card class="menu-container p-8 elevation" cdkMenu
                            *ngIf="user.invitedBy && user.invitedBy.firstName && user.invitedBy.lastName">
                            <span class="small dark">{{'USER.LAST_INVITED_BY' | translate}}</span>
                            <div class="fx-row justify-content-start align-items-center">
                                <app-avatar [user]="user.invitedBy" [size]="20"></app-avatar>
                                <span class="small ml-5">{{user.invitedBy.firstName}} {{user.invitedBy.lastName}}</span>
                            </div>
                            <span class="small dark" *ngIf="user.invitedBy.lastInvitedAt">{{'UTILS.ON' |
                                translate}}&nbsp;<span
                                    class="small dark bold">{{formatDateTime(user.invitedBy.lastInvitedAt)}}</span></span>
                        </mat-card>
                    </ng-template>
                </div>
            </td>
        </ng-container> -->

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let campaign">
                <div class="fx-row align-items-center justify-content-end">
                    <button mat-icon-button [cdkMenuTriggerFor]="menuActions">
                        <mat-icon class="dark" fontSet="material-icons-outlined">more_vert</mat-icon>
                    </button>
                    <ng-template #menuActions>
                        <mat-card class="menu-container p-0 elevation" cdkMenu>
                            <div class="fx-column">
                                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                                    (click)="toggle(campaign)" cdkMenuItem *ngIf="!isCampaignInactive(campaign)">
                                    <mat-icon class=" mr-5" [class.main]="!campaign.enabled"
                                        [class.red]="campaign.enabled"
                                        fontSet="material-icons-outlined">{{!campaign.enabled
                                        ? 'play_circle' :
                                        'block'}}</mat-icon>
                                    <span class="text">{{(campaign.enabled ? 'ACTIONS.DISABLE' : 'ACTIONS.ENABLE') |
                                        translate}}</span>
                                </div>
                                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                                    (click)="edit(campaign)" cdkMenuItem *ngIf="!isCampaignInactive(campaign)">
                                    <mat-icon class="main mr-5" fontSet="material-icons-outlined">edit</mat-icon>
                                    <span class="text">{{'ACTIONS.EDIT' | translate}}</span>
                                </div>
                                <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                                    (click)="delete(campaign)" cdkMenuItem>
                                    <mat-icon class="red mr-5" fontSet="material-icons-outlined">delete</mat-icon>
                                    <span class="text">{{'ACTIONS.DELETE' | translate}}</span>
                                </div>
                            </div>
                        </mat-card>
                    </ng-template>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
    <div class="p-16" *ngIf="campaigns.totalDocs === 0">
        <span class="text light">{{'ORGANIZATION.SEARCH_NO_CAMPAIGNS' | translate}}</span>
    </div>
    <div class="fx-flex align-items-center justify-content-end">
        <mat-paginator [length]="campaigns.totalDocs || 0" [pageSize]="campaigns.limit || 0"
            [pageIndex]="campaigns.page ? (campaigns.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
            (page)="handlePage($event)">
        </mat-paginator>
    </div>
</div>